import { TechDocPage, TechDocChecklistPage, TechDocWizardPage } from '../containers/pages';
import { ALLETRA6k_VIDEO_URL, PRODUCT_ID_BAAS } from '../constants';
import { gettingStarted } from './pageConfigComm';

export const pagesConfig = [
  ...gettingStarted(PRODUCT_ID_BAAS),
  {
    path: '/physical-install',
    menuText: 'physicalInstallation',
    exact: true,
    redirectTo: '/physical-install/unbox',
    submenuItems: [
      {
        path: '/physical-install/unbox',
        menuText: 'unbox',
        exact: true,
        component: TechDocPage,
        pageProps: {
          videoUrl: ALLETRA6k_VIDEO_URL.UNBOX,
        },
      },
      {
        path: '/physical-install/rack',
        menuText: 'rack',
        exact: true,
        redirectTo: '/physical-install/rack/1',
      },
      {
        path: '/physical-install/rack/:step',
        exact: true,
        component: TechDocWizardPage,
        pageName: 'rack',
        pageProps: {
          steps: [
            {
              videoUrl: ALLETRA6k_VIDEO_URL.RACK_STEP1,
            },
            {
              videoUrl: ALLETRA6k_VIDEO_URL.RACK_STEP2,
            },
            {
              videoUrl: ALLETRA6k_VIDEO_URL.RACK_STEP3,
            },
          ],
        },
      },
      {
        path: '/physical-install/cable',
        menuText: 'cable',
        exact: true,
        component: TechDocPage,
        pageProps: {
          videoUrl: ALLETRA6k_VIDEO_URL.CABLE,
        },
      },
      {
        path: '/physical-install/powerOn',
        menuText: 'powerOn',
        exact: true,
        component: TechDocPage,
        pageProps: {
          videoUrl: ALLETRA6k_VIDEO_URL.POWER,
        },
      },
      {
        path: '/physical-install/installShelves',
        menuText: 'installShelves',
        exact: true,
        component: TechDocPage,
        pageProps: {},
      },
    ],
  },
  {
    path: '/software-config',
    menuText: 'softwareConfig',
    exact: true,
    redirectTo: '/software-config/prepareClient',
    submenuItems: [
      {
        path: '/software-config/prepareClient',
        menuText: 'prepareClient',
        exact: true,
        component: TechDocPage,
        pageProps: {},
      },
      {
        path: '/software-config/arrayDiscovery',
        menuText: 'arrayDiscovery',
        exact: true,
        component: TechDocPage,
        pageProps: {},
      },
      {
        path: '/software-config/connectArray',
        menuText: 'connectArray',
        exact: true,
        component: TechDocPage,
        pageProps: {
          videoUrl: ALLETRA6k_VIDEO_URL.CONNECTARRAY,
        },
      },
      {
        path: '/software-config/arraySetup',
        menuText: 'arraySetup',
        exact: true,
        component: TechDocPage,
        pageProps: {
          videoUrl: ALLETRA6k_VIDEO_URL.SETUPARRAY,
        },
      },
      {
        path: '/software-config/validation',
        menuText: 'arrayValidation',
        exact: true,
        component: TechDocChecklistPage,
        pageProps: {},
      },

      {
        path: '/software-config/completeSetup',
        menuText: 'setupComplete',
        exact: true,
        component: TechDocPage,
        pageProps: {},
      },
    ],
  },
];
